import { env } from "../datas.config";
import { socket } from "./socket";

export const createGroupe = (endpoint, value) => {
  fetch(`${env.domain}/api/auth/groupe/nouveau-groupe/${endpoint}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      nomGroupe: value,
    }),
    credentials: "include",
  })
    .then((res) => {
      return res.json();
    })
    .then((result) => {
      console.clear();
      console.log(result);
    })
    .catch((err) => {
      console.clear();
      console.error(err);
    });
};

export const createGroupeWithImage = (
  activeStep,
  value,
  setVisibility
) => {
  const formData = new FormData();
  // Ajouter le fichier a FormData (nom de champ 'image')
  if (value.imageGroupe) {
    formData.append("image", value.imageGroupe);
  }
  // Ajouter les autres donnees au FormData
  formData.append("value", JSON.stringify(value));
  fetch(`${env.domain}/api/auth/groupe/nouveau-groupe/${activeStep}`, {
    method: "POST",
    body: formData,
    credentials: "include",
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      if (data && data.status === 200) {
        socket.emit("create_new_groupe", data.groupe);
        setTimeout(() => setVisibility(false), 1500);
      } else {
        console.error("Erreur lors de la création du groupe", data);
        setVisibility(false);
      }
    })
    .catch((error) => {
      console.error("Erreur de réseau", error);
    });
};

export const getGroupeByRoomId = async (roomId) => {
  try {
    const res = await fetch(`${env.domain}/api/auth/groupe/room/${roomId}`, {
      credentials: "include",
    });
    return await res.json();
  } catch (err) {
    console.error("Erreur getGroupeByRoomId:", err);
    return null;
  }
};

export const transferAdmin = async (roomId, newAdminId) => {
  try {
    const res = await fetch(`${env.domain}/api/auth/groupe/room/${roomId}/admin`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ newAdminId }),
      credentials: "include",
    });
    return await res.json();
  } catch (err) {
    console.error("Erreur transferAdmin:", err);
    return null;
  }
};

export const updateGroupeInfo = async (roomId, formData, workspaceId) => {
  try {
    const headers = {};
    if (workspaceId) headers["x-workspace-id"] = workspaceId;
    const res = await fetch(`${env.domain}/api/auth/groupe/room/${roomId}/info`, {
      method: "PUT",
      body: formData,
      credentials: "include",
      headers,
    });
    return await res.json();
  } catch (err) {
    console.error("Erreur updateGroupeInfo:", err);
    return null;
  }
};

export const addMembreToGroupe = async (roomId, membreId) => {
  try {
    const res = await fetch(`${env.domain}/api/auth/groupe/room/${roomId}/membres`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ membreId }),
      credentials: "include",
    });
    return await res.json();
  } catch (err) {
    console.error("Erreur addMembreToGroupe:", err);
    return null;
  }
};

export const toggleMuteMember = async (roomId, membreId) => {
  try {
    const res = await fetch(`${env.domain}/api/auth/groupe/room/${roomId}/membres/${membreId}/mute`, {
      method: "PATCH",
      credentials: "include",
    });
    return await res.json();
  } catch (err) {
    console.error("Erreur toggleMuteMember:", err);
    return null;
  }
};

export const removeMembreFromGroupe = async (roomId, membreId, newAdminId) => {
  try {
    const options = {
      method: "DELETE",
      credentials: "include",
    };
    if (newAdminId) {
      options.headers = { "Content-Type": "application/json" };
      options.body = JSON.stringify({ newAdminId });
    }
    const res = await fetch(
      `${env.domain}/api/auth/groupe/room/${roomId}/membres/${membreId}`,
      options
    );
    return await res.json();
  } catch (err) {
    console.error("Erreur removeMembreFromGroupe:", err);
    return null;
  }
};
